angular.module('contabilidad.polizasexternas')
  .service('PolizasExternasAlgodonerosIngresos', PolizasExternasAlgodonerosIngresos)

PolizasExternasAlgodonerosIngresos.$inject = ['$http']

function PolizasExternasAlgodonerosIngresos($http) {
  this.get = get
  this.empresaCuentas = empresaCuentas
  this.empresaCuenta = empresaCuenta
  this.vinculacion = vinculacion
  this.post = post
  this.put = put
  this.descargarExcel = descargarExcel

  function get(busqueda) {
    return $http.get('/api/contabilidad/polizasexternas/algodoneros/ingresos', {
      params: {
        fechaInicial: busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal.toYMD(),
        empresaId: busqueda.empresaId,
        cuentaId: busqueda.cuentaId,
        cuentaKardexId: busqueda.cuentaKardexId,
      },
      schema: {
        facturas: 'number',
        fecha: 'date',
        importe: 'number',
        totalvinculado: 'number',
      },
    })
  }

  function post(data) {
    return $http.post('/api/contabilidad/polizasexternas/algodoneros/ingresos/vinculacion', data)
  }

  function put(movimientoId) {
    return $http.put('/api/contabilidad/polizasexternas/algodoneros/ingresos/vinculacion-codigo', {}, {
      params: { movimientoId }
    })
  }

  function empresaCuenta(empresaId, idCuenta) {
    return $http.get('/api/empresa/cuenta', {
      params: {
        empresa_id: empresaId,
        id_cuenta: idCuenta,
      },
      schema,
    })
  }

  function empresaCuentas(empresaId) {
    return $http.get('/api/empresa/cuentas', {
      params: {
        empresa_id: empresaId,
      },
      schema,
    })
  }

  function vinculacion(fecha, fechaFinal) {
    return $http.get('/api/contabilidad/polizasexternas/algodoneros/ingresos/vinculacion', {
      params: {
        fechaInicial: fecha.toYMD(),
        fechaFinal: fechaFinal.toYMD(),
      },
      schema: {
        id: 'number',
        iva: 'number',
        saldo: 'number',
        subtotal: 'number',
        total: 'number',
      },
    })
  }

  function descargarExcel(busqueda) {
    return $http.get('/api/contabilidad/polizasexternas/algodoneros/ingresos/descargar', {
      params: {
        fechaInicial: busqueda.fechaInicial.toYMD(),
        fechaFinal: busqueda.fechaFinal.toYMD(),
        empresaId: busqueda.empresaId,
        cuentaId: busqueda.cuentaId,
        cuentaKardexId: busqueda.cuentaKardexId,
      },
      download: true,
    })
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/Algodoneros/Ingresos.js